import React, { useEffect, useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import {
  Modal,
  ModalBody,
  Col,
  Button,
  Input,
  Label,
  Row,
  Navbar,
  FormGroup,
} from "reactstrap";

import * as actions from "../../../../../../../store/modules/personas/papeis_store/actions";
import * as controllerPapeis from '../../../../../../../controllers/personasController/papeisController'

export default function ModalCentroCusto({ isOpen, toggle, onChange }) {
  const {
    centrosCustos,
    paginacaoCentrosCustos
  } = useSelector((state) => state.personasPapeis);
  
  const columns = useMemo(
    () => [
      {
        Header: "NOME",
      },
    ],
    []
  );
  const data = Array.isArray(centrosCustos) ? centrosCustos : [];

  const { page, gotoPage, state, setPageSize } = useTable(
    {
      columns,
      data,
    },
    usePagination
  );

  const { pageSize } = state;
  const [rows, setRows] = useState(0);
  const [initialPage, setInitialPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [nome, setNome] = useState("");

  useEffect(() => {
    setRows(page.length);
  }, [page]);


  const handlePageClick = (e) => {
    const pageSelected = e.selected;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);

    controllerPapeis.getCentrosCustos(nome, pageSelected + 1, pageSize);
  };

  function handleInitialPage() {
    gotoPage(0);
    setInitialPage(true);
    setSelectedPage(0);
  }

  function handleKeyPress(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      controllerPapeis.getCentrosCustos(nome, 1, pageSize);
    }
  }


  return (
    <>
      <Modal
        className="text-center"
        isOpen={isOpen}
        toggle={toggle}
        backdrop={true}
        size="lg"
      >
        <Navbar
          expand="md"
          style={{
            width: "100%",
            height: "40px",
            background: "var(--color-gradiente-verde)",
            marginBottom: "20px",
          }}
        >
          <h5 style={{ color: "white" }} className="ml-auto mr-auto mt-2">
            Pesquisa de Centro de Custo
          </h5>
        </Navbar>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup>
                <Label className="float-left">Nome</Label>
                <Input
                  type="text"
                  placeholder="Digite aqui..."
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  onKeyPress={(e) => handleKeyPress(e)}
                />
              </FormGroup>
            </Col>
          </Row>
          <fieldset
            className={
              centrosCustos.length > 0 ? "fieldset-socio" : "fieldset-socio-no-results"
            }
          >
            <legend style={{ textAlign: "left", fontSize: "20px" }}>
              Resultados
            </legend>
            <table>
              <tr>
                <th>Nome</th>
              </tr>
              {data?.length > 0 &&
                data?.map((row) => {
                  return (
                    <tr
                      onDoubleClick={() => {
                        onChange(row.id, row.descricao);
                        toggle();
                      }}
                    >
                      <td index={row.id}>{row.descricao}</td>
                    </tr>
                  );
                })}
            </table>
            <br />
          </fieldset>
          {centrosCustos && (
            <Row className="pt-4">
              <Col md={3}>
                <span style={{ color: "var(--color-cinza-medio)" }}>
                  Mostrando {rows} de {paginacaoCentrosCustos.quantidadeTotal}
                </span>
              </Col>
              <Col md={8} className="float-right">
                <Row>
                  <ReactPaginate
                    previousLabel={"<"}
                    nextLabel={">"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    initialPage={0}
                    pageCount={paginacaoCentrosCustos.totalPaginas}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    forcePage={initialPage ? 0 : selectedPage}
                  />
                  <Input
                    type="select"
                    className="pageSize"
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                      handleInitialPage();
                    }}
                  >
                    {[10, 25, 100].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </Input>
                </Row>
              </Col>
            </Row>
          )}
        </ModalBody>
        <div className="m-3">
          <Button
            onClick={() => {
              actions.setCentrosCustos([]);
              actions.setPaginacaoCentrosCustos({
                totalPaginas: 0,
                quantidadeTotal: 0,
                quantidade: 0
              });
              setNome("");
            }}
            className="mr-4"
            style={{
              width: "150px",
              background: "var(--color-branco)",
              borderColor: "var(--color-laranja)",
              color: "var(--color-laranja)",
              borderRadius: "7px",
            }}
          >
            Limpar
          </Button>
          <Button
            onClick={() =>
              controllerPapeis.getCentrosCustos(nome, 1, pageSize)
            }
            color="danger"
            className="purpleButton"
            style={{ width: "150px" }}
          >
            Pesquisar
          </Button>
        </div>
      </Modal>
    </>
  );
}
